import { render, staticRenderFns } from "./upddFile.vue?vue&type=template&id=1a2939d0&scoped=true&"
import script from "./upddFile.vue?vue&type=script&lang=js&"
export * from "./upddFile.vue?vue&type=script&lang=js&"
import style0 from "./upddFile.vue?vue&type=style&index=0&id=1a2939d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2939d0",
  null
  
)

export default component.exports